<div class="quick-address-capture-container pt-4 container">
    <div class="quick-address-header">
        <div class="ms-3">
            <h4 class="app-module-title fw-bold">Activar ubicación</h4>
            <p class="small-label m-0">Para localizar tu código postal o puedes ingresarlo manualmente.</p>
        </div>
    </div>
    <div class="quick-address-content">
        <div class="d-flex flex-row gap-3 p-3 rounded-4 card-theme-color theme-shadow"  *ngIf="apiLoaded && located">
            <span class="material-symbols-rounded square-icon">location_on</span>
            <div>
                <p class="small-label text-uppercase spaced-label m-0">Se guardara esta dirección</p>
                <p class="medium-text fw-bold">{{ address }}</p>
            </div>
        </div>
        <div *ngIf="apiLoaded && located && userOpenedMap">
            <google-map height="250px"
                width="100%"
                [options]="mapOptions"
                [center]="center"
                [zoom]="zoom"
                (mapClick)="moveMap($event)"
                (mapMousemove)="move($event)">
                <map-marker [position]="center"
                            [options]="markerOptions">
                </map-marker>
            </google-map>
        </div>
    </div>
    <div class="quick-address-bottom multiple-separation-bottom-actions">
        <button mat-flat-button
            class="role-action-btn w-100"
            (click)="requestLocation()">
            Continuar
        </button>
<!--        <button mat-flat-button *ngIf="located"-->
<!--                class="role-action-btn w-100"-->
<!--                [disabled]="!located"-->
<!--                (click)="saveAddress()">-->
<!--            Confirmar-->
<!--        </button>-->
        <button mat-flat-button
                class="link-action-btn w-100"
                (click)="requestCpManually()">
            Ingresar manualmente
        </button>
    </div>
</div>

<ng-template #unableToLocate>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">Permiso de ubicación requerido</p>
        </div>
        <div>
            <p class="small-label pb-3">
                Por favor habilita el acceso a la ubicación para continuar.
            </p>
        </div>
        <div>
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="dismissMessage()">
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #unableToSaveAddress>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">No se pudo guardar la dirección</p>
        </div>
        <div>
            <p class="small-label pb-3">Estamos teniendo problemas para guardar la direccion. Intenta mas tarde.</p>
        </div>
        <div>
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="dismissMessage()">
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #invalidCp>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">No se detectó el código postal</p>
        </div>
        <div>
            <p class="small-label pb-3">Puedes ingresarlo manualmente o intentar mas tarde.</p>
        </div>
        <hr class="app-module-subtitle"/>
        <div class="multiple-separation-bottom-actions">
            <button mat-flat-button
                class="bg-transparent accent-color w-100"
                (click)="requestCpManually()">
                Ingresar manualmente
            </button>
            <hr class="app-module-subtitle"/>
            <button mat-flat-button
                    class="bg-transparent text-danger w-100"
                    (click)="dismissMessage()">
                Cancelar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #enterCpManually>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="small-label text-uppercase spaced-label m-0 pb-3">Digita el código postal</p>
        </div>
        <div>
            <mat-form-field class="w-100 mb-4" floatLabel="never">
                <input matInput
                   class="fw-bold large-text"
                    placeholder="00000"
                   [formControl]="manualCp">
            </mat-form-field>
        </div>
        <div *ngIf="manualCp.hasError('invalidCp')"
             class="d-flex flex-row align-items-center mb-3">
            <img src="../../../assets/img/error-circle-100.svg"
                 width="32"
                 height="32"
                 alt="Account Error">
            <p class="text-danger m-0">Código postal invalido.</p>
        </div>
        <div *ngIf="manualCp.hasError('notFound')"
             class="d-flex flex-row align-items-center mb-3">
            <img src="../../../assets/img/error-circle-100.svg"
                 width="32"
                 height="32"
                 alt="Account Error">
            <p class="text-danger m-0">No se encontró este código postal o no existe.</p>
        </div>
        <div class="multiple-separation-bottom-actions">
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="requestDataByCp()">
                Aceptar
            </button>
            <button mat-flat-button
                    class="bg-transparent text-danger w-100"
                    (click)="dismissMessage()">
                Cancelar
            </button>
        </div>
    </div>
</ng-template>
